module.exports = __webpack_public_path__ + "static/media/FBG1.c0bec7b7.png";